import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable new-cap */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import isEmpty from 'lodash/fp/isEmpty';
import Checkbox from '../checkbox/Checkbox';
import Collapse from '../collapse/Collapse';
import { TableSettingsColumnDetails } from './TableSettingsColumnDetails';
import { TableSettingsColumnButtons } from './TableSettingsColumnButtons';
import { columnsDetailsPropTypes } from './tableSettingsPropTypes';
var MAX_COLUMN_WIDTH = 1000;
export var filterColumns = function filterColumns(searchValue) {
  var column = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var columnLabelStrings = arguments.length > 2 ? arguments[2] : undefined;
  if (!searchValue) {
    return false;
  }
  var label = columnLabelStrings[column] || '';
  return !label.toLowerCase().includes(searchValue.toLowerCase());
};
var TableSettingsListItem = function TableSettingsListItem(props) {
  var column = props.column,
    orderIndex = props.orderIndex,
    columnLabels = props.columnLabels,
    autoLabel = props.autoLabel,
    _props$disabledColumn = props.disabledColumns,
    disabledColumns = _props$disabledColumn === void 0 ? [] : _props$disabledColumn,
    columnOrder = props.columnOrder,
    _props$hiddenColumns = props.hiddenColumns,
    hiddenColumns = _props$hiddenColumns === void 0 ? [] : _props$hiddenColumns,
    columnSearchValue = props.columnSearchValue,
    columnsDetails = props.columnsDetails,
    columnLabelStrings = props.columnLabelStrings,
    openColumnsDetails = props.openColumnsDetails,
    updateColumnLabelStrings = props.updateColumnLabelStrings,
    onColumnWidthChange = props.onColumnWidthChange,
    onResetColumnWidth = props.onResetColumnWidth,
    onMoveColumn = props.onMoveColumn,
    onOpenDetails = props.onOpenDetails,
    onToggleHideColumn = props.onToggleHideColumn,
    className = props.className;
  var isSortingDisabled = !isEmpty(columnSearchValue);
  var _useSortable = useSortable({
      id: column,
      disabled: isSortingDisabled
    }),
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };

  // Filter out items which don't match the search value.
  // Note that we need to render all items at least once at the beginning in order to get their DOM lables
  // otherwise the search won't work when initial search value is provided via props.
  var isFiltered = filterColumns(columnSearchValue, column, columnLabelStrings) && !updateColumnLabelStrings;
  var itemClassNames = classNames('table-settings-item', updateColumnLabelStrings && 'opacity-0', isFiltered && 'position-offscreen', className);
  var columnDetails = columnsDetails[column];
  return /*#__PURE__*/React.createElement("div", {
    className: itemClassNames,
    key: "table-settings-item-".concat(column),
    ref: setNodeRef,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-settings-item-header user-select-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "CheckboxWrapper display-flex align-items-center padding-left-2"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !hiddenColumns.includes(column),
    onClick: function onClick(event) {
      onToggleHideColumn(column);
      event.stopPropagation();
    },
    disabled: disabledColumns.includes(column)
  })), /*#__PURE__*/React.createElement("div", _extends({
    className: "table-settings-item-label ".concat(isSortingDisabled ? 'no-drag' : ''),
    "data-key": column
  }, attributes, listeners), columnLabels[column]), columnDetails && /*#__PURE__*/React.createElement("div", {
    className: "column-width-label"
  }, columnDetails.width ? "".concat(columnDetails.width, "px") : autoLabel), /*#__PURE__*/React.createElement(TableSettingsColumnButtons, {
    column: column,
    index: orderIndex,
    columnDetails: columnDetails,
    columnOrder: columnOrder,
    openColumnsDetails: openColumnsDetails,
    disabled: isSortingDisabled,
    onMoveColumn: onMoveColumn,
    onOpenDetails: onOpenDetails
  })), columnDetails && /*#__PURE__*/React.createElement(Collapse, {
    "in": !!openColumnsDetails[column]
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TableSettingsColumnDetails, _extends({}, columnDetails, {
    column: column,
    maxColumnWidth: MAX_COLUMN_WIDTH,
    onColumnWidthChange: onColumnWidthChange,
    onResetColumnWidth: onResetColumnWidth
  })))));
};
TableSettingsListItem.propTypes = {
  column: PropTypes.string,
  orderIndex: PropTypes.number,
  columnLabels: PropTypes.object,
  autoLabel: PropTypes.string,
  disabledColumns: PropTypes.arrayOf(PropTypes.string),
  columnOrder: PropTypes.arrayOf(PropTypes.string),
  hiddenColumns: PropTypes.arrayOf(PropTypes.string),
  columnSearchValue: PropTypes.string,
  columnsDetails: columnsDetailsPropTypes,
  columnLabelStrings: PropTypes.object,
  openColumnsDetails: PropTypes.object,
  updateColumnLabelStrings: PropTypes.bool,
  onColumnWidthChange: PropTypes.func,
  onResetColumnWidth: PropTypes.func,
  onMoveColumn: PropTypes.func,
  onOpenDetails: PropTypes.func,
  onToggleHideColumn: PropTypes.func,
  className: PropTypes.string
};
export default TableSettingsListItem;